<template>
  <v-generic-input
    :label="label"
    :translate-text="translateText"
    :help-text="helpText"
    :id="`${givenId}`"
    :required="required"
    :errors="errors"
  >
    <template v-slot:input>
      <div class="row">
        <div
          :class="`col-md-${columnNumber}`"
          v-for="option in choices"
          :key="option.key"
        >
          <label>
            <input
              type="checkbox"
              :value="option.key"
              v-model="inputVal"
            />
            {{ option.value }}
          </label>
        </div>
      </div>
    </template>
  </v-generic-input>
</template>

<script>
import { GenericInputMixin } from '@/common/utils/mixins';
import _GenericInput from './_GenericInput.vue';

export default {
  name: 'CheckBoxes',
  components: {
    'v-generic-input': _GenericInput,
  },
  props: {
    choices: {
      required: true,
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    value: {
      type: Array,
    },
    columns: {
      type: Number,
      default() {
        return 1;
      },
    },
  },
  mixins: [
    GenericInputMixin,
  ],
  computed: {
    inputVal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    columnNumber() {
      return 12 / this.columns;
    },
  },
  data() {
    return {
      givenId: null,
    };
  },
  mounted() {
    // eslint-disable-next-line no-underscore-dangle
    this.givenId = this.id || this._uid;
  },
};
</script>
